import { suggestEmail } from '@/util/emailValidator';

// Non-blocking "did you mean" hint for customer email fields. Shown through the
// field's error slot after blur, the same way the phone field shows its
// "may not be reachable" warning; it never stops a submit.
export default {
  methods: {
    emailTypoWarning(email) {
      const suggestion = suggestEmail(email);
      return suggestion ? this.$t('emailSuggestion.didYouMean', { email: suggestion }) : '';
    }
  }
};
